import { PostAPI } from 'Components/Helper/Helpers';

export const GetRedirectURL = async (request) => {
    return PostAPI(request, 'NSDL/GetRedirectURL');
};
